<template>
	<div :class="`hamburger_menu_wrapper ${isVisible ? 'show_menu' : ''}`">
		<div class="hamburger_menu_header">
			<img v-if="!!onClose" src="/static/icons/close.svg" width="24" height="24" @click="handleClose" />
		</div>
		<div class="login_logout_wrapper body_7" @click="isLogin ? handleLogout() : handleLogin()">
			{{ isLogin ? '로그아웃' : '로그인' }}
		</div>
		<ul>
			<li class="heading_8" @click="handleEstimate">내 차 견적 산출하기</li>
			<li class="body_7" @click="handleHistory">AI 견적 산출내역 보기</li>
			<li class="body_7" @click="handleMyPage">마이 페이지</li>
		</ul>
		<div class="menu_bottom">
			<a class="body_6_M" href="tel:1600-1600">고객센터 1600-1600</a>
			<p class="body_9 f_gray_3">
				AI를 통해 더 차별화 된
				<strong style="color:#FF6D6E">Mobility Service로 혁신</strong>
			</p>
			<img src="/static/images/ai/ai_logo.png" width="170" alt="huckleberry" />
		</div>
	</div>
</template>

<script>

import Vue from 'vue'
import AppConfig from '@/config'
import { EventBus } from "@/modules/event-bus"

export default {
	data() {
		return {
			isLogin: false,
			parms: {
		      userNo: Vue.$sessionStorage.get('userNo'),
		      name: '',
		      ci: ''
		    },
		}
	},
	props: {
		isVisible: {
			type: Boolean,
			default: false
		},
		onClose: {
			type: Function
		}
	},

	mounted() {
		this.isLogin = Vue.$sessionStorage.get('isLogin');
	},

	methods: {
		handleClose() {
			if (this.onClose) {
				this.onClose()
			}
		},
		handleLogin() {
			//alert('로그인')
			this.$router.push({ name: 'AiLogin' })
		},
		handleLogout() {
			//alert('로그아웃')
			Vue.httpClient
	         .post(AppConfig.HTTP_CONFIG.authURL + '/m/ai/aiLogout', this.parms)
	         .then(response => {
	           if (response.data.status == AppConfig.HTTP_RESPONSE_SUCCESS) {
	             window.$store.commit('Login/setToken', { token: null })
	             window.$store.commit('Login/setUserNo', { userNo: null })
	             Vue.httpClient.defaults.headers.common['x-auth-token'] = null;
	             Vue.$sessionStorage.clear();
	             EventBus.$emit("ai-event-logout");
	             this.$router.go(0);
	           }
	        })
		},
		handleEstimate() {
			this.$router.push({ name: 'AiSearchCar' })
		},

		handleHistory() {
			this.$router.push({ name: 'AiEstimateList' })
		},

		handleMyPage() {
			this.$router.push({ name: 'AiMypage' })
		}
	}
}
</script>

<style scoped>
.hamburger_menu_wrapper {
	width: 100%;
	height: 100vh;
	position: fixed;
	top: 0;
	bottom: 0;
	right: -100%;
	transition: right 0.3s;
	z-index: var(--zIndex-hamburder-menu);
	background-color: var(--gray-scale-12);
}

.hamburger_menu_wrapper>.hamburger_menu_header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: var(--ai-header-height);
	padding: 16px 24px;
	background-color: var(--gray-scale-12);
}

.hamburger_menu_wrapper>.hamburger_menu_header>img {
	margin-left: auto;
}

.show_menu {
	right: 0;
}

.login_logout_wrapper {
	padding: 20px;
	border-bottom: 1px solid var(--gray-scale-9);
}

.hamburger_menu_wrapper>ul {
	display: grid;
	gap: 16px;
	padding: 24px 20px;
	border-bottom: 1px solid var(--gray-scale-9);
}

.hamburger_menu_wrapper>.menu_bottom {
	padding: 20px;
}

.hamburger_menu_wrapper>.menu_bottom>a {
	color: var(--gray-scale-2) !important;
	margin-bottom: 16px;
}

.hamburger_menu_wrapper>.menu_bottom>p {
	margin-bottom: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/ai/AiHamburgerMenu.vue